import ClassicTaskDetailsMasterLayer from "components/taskdetails-remake/TaskDetailsMasterLayer.component.jsx";
import ClassicTaskDetailsMasterLayerByUID from "components/taskdetails-remake/TaskDetailsMasterLayerByUID.component";
import TaskDetailsMasterLayer from "./TaskDetailsMasterLayer.component";
import TaskDetailsMasterLayerByUID from "./TaskDetailsMasterLayerByUID.component";
import {isTaskDetailsRedesignEnabled} from "./taskDetails.function";
import type {TaskDetailsMasterLayerProps} from "types/taskDetailsMasterLayer";

// The task details routes render these, so fe-task-details-redesign picks the page at render, once
// LaunchDarkly is ready: flag on -> the redesigned page, flag off -> the classic one.

export const TaskDetailsWrapper = (props: TaskDetailsMasterLayerProps) =>
    isTaskDetailsRedesignEnabled() ? <TaskDetailsMasterLayer {...props}/> : <ClassicTaskDetailsMasterLayer {...props}/>;

export const TaskDetailsByUIDWrapper = (props: TaskDetailsMasterLayerProps) =>
    isTaskDetailsRedesignEnabled() ? <TaskDetailsMasterLayerByUID {...props}/> : <ClassicTaskDetailsMasterLayerByUID {...props}/>;

export default TaskDetailsWrapper;
